import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { get, isEqual } from 'lodash';

import { Checkbox, FormControlLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import {
  UnFavoriteIcon,
  FavoriteFull,
  FavoriteEmpty,
  FavoritesGreyIcon,
} from '../Icons';
import { saveFavorite, deleteFavorite } from '../../../actions/favorite';
import {
  OpenFavoritesSuccessDialog,
  OpenSignupDialog,
} from '../../../actions/actionTypes';
import style from '../../../styles/sass/components/FavoriteButton.module.scss';
import FavoritesDialog from '../../layout/FavoritesDialog';

const styles = {
  customHoverFocus: {
    '&:hover, &.MuiIconButton-root': { backgroundColor: 'yellow !important' },
  },
  favorite: {
    height: 30,
    width: 30,
  },
  icon: {
    color: '#FFFFFF',
    height: 30,
    width: 30,
  },
  iconSmall: {
    color: '#FFFFFF',
    height: 18,
    width: 19,
  },
  label: {
    margin: 0,
  },
  root: {
    margin: 0,
    padding: 0,
    '&.MuiIconButton-root:hover': {
      backgroundColor: 'rgba(44, 199, 164, 0.3) !important',
    },
  },
  rootSmall: {
    height: 18,
    margin: 0,
    padding: 0,
    width: 19,
    '&.MuiIconButton-root:hover': {
      backgroundColor: 'rgba(44, 199, 164, 0.3) !important',
    },
  },
  smallFavorite: {
    height: 18,
    width: 19,
  },
};

export interface Props {
  card?: boolean;
  classes: any;
  containerStyle?: any;
  dispatch: any;
  favorites: any[];
  formStyle?: any;
  grey?: boolean;
  listingId: number;
  light: boolean;
  small?: boolean;
  token: string;
  showFavoritesModal: boolean;
  pointToSidebar?: boolean;
}

export interface State {
  favorited: boolean;
  showFavoritesDialog: boolean;
  currentElement: any;
}

export class FavoriteButton extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      favorited: false,
      showFavoritesDialog: false,
      currentElement: null,
    };
  }

  componentDidMount = () => {
    this.setFavorites();
  };

  componentDidUpdate(prevProps: any) {
    if (
      this.props.favorites?.length > 0 &&
      !isEqual(prevProps.favorites, this.props.favorites)
    ) {
      this.setFavorites();
    }
  }

  setFavorites = () => {
    const { favorites, listingId } = this.props;
    const favoritesIds = favorites.map((favorite: any) => favorite.id);
    if (favoritesIds.includes(listingId)) {
      this.setState({
        favorited: true,
      });
    }
  };

  toggleFavoriteCheck = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    if (!this.props.token) {
      return this.props.dispatch({
        signupSubtext: `Sign up to save your favorite homes or block the ones you don’t want to see again.`,
        type: OpenSignupDialog,
        signupCallback: () => {
          // Temporarily commenting this out due to new welcomeSurvey Modal
          // // Open Favorites dialog after auth.
          // this.props.dispatch({
          //   type: OpenFavoritesSuccessDialog,
          // });
          // Callback function to execute after auth
          this.toggleFavorite(event);
        },
      });
    } else {
      this.toggleFavorite(event);
    }
  };

  toggleFavorite = (event: any) => {
    // If a listing is not currently favorited, then star it, otherwise, unstar it.
    if (!this.state.favorited) {
      this.props.dispatch(saveFavorite(this.props.listingId, this.props.token));
      if (this.props.showFavoritesModal) {
        this.setState(
          {
            showFavoritesDialog: true,
            currentElement: event.currentTarget,
          },
          () =>
            setTimeout(
              () =>
                this.setState({
                  showFavoritesDialog: false,
                }),
              4000,
            ),
        );
      }
    } else {
      this.props.dispatch(
        deleteFavorite(this.props.listingId, this.props.token),
      );
    }
    this.setState(prevState => ({ favorited: !prevState.favorited }));
  };

  render() {
    const {
      card,
      classes,
      containerStyle,
      grey,
      light,
      small,
      pointToSidebar,
    } = this.props;
    return (
      <div
        className={style.toggleFavorite}
        style={containerStyle ? containerStyle : {}}
      >
        <FormControlLabel
          label=""
          control={
            <Checkbox
              id="heartIcon"
              color="default"
              icon={
                card ? (
                  <FavoriteEmpty small={small} />
                ) : grey ? (
                  <FavoritesGreyIcon />
                ) : (
                  <UnFavoriteIcon small={small} light={light} />
                )
              }
              checkedIcon={<FavoriteFull small={small} />}
              onClick={event => event.stopPropagation()}
              onChange={e => this.toggleFavoriteCheck(e)}
              checked={this.state.favorited}
              classes={{
                root: small ? classes.rootSmall : classes.root,
              }}
            />
          }
          style={get('this.props', 'formStyle', {})}
          classes={{
            root: classes.label,
          }}
        />
        {this.state.showFavoritesDialog && (
          <FavoritesDialog
            currentComponent={this.state.currentElement}
            pointToSidebar={pointToSidebar}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  favorites: state.favorites.favorites,
  showFavoritesModal: state.favorites.showFavoritesModal,
  token: state.auth.token,
});

export default connect(mapStateToProps)(withStyles(styles)(FavoriteButton));
